export default __webpack_public_path__ + "static/media/wheel_of_fortune.7d5e6ef2.png";